<template>
  <div class="pageContainer">
    <div class="stuCourseCont">
      <div class="topCont">
        <div class="title">
          {{ title }}
        </div>
        <div class="title2">
          授予学位：{{ degree }}
        </div>
        <div class="title3">
          <div>培养目标:</div>
          <div>{{ train_target }}</div>
        </div>
        <div class="title3">
          <div>毕业要求:</div>
          <div>{{ gradu_req }}</div>
        </div>
        <div class="subTitle">
          <div class="leftSub" @click="changeCourseType(2)">
            重要课程<span>(专业基础课程、专业课程)</span>
          </div>
          <div class="rightSub" @click="changeCourseType(1)">
            次要课程<span>(通识课程、个性修读课程、跨专业等)</span>
          </div>
        </div>
      </div>
      <ul class="middleCont">
        <li v-for="(item,index) in courseData" :key="index">
          <div class="stepTitleCont">
            <div class="titleIcon"/>
            <div class="stepTitle">第{{ switchStep(index) }}阶段</div>
          </div>
          <div class="courseCont" v-if="Array.isArray(item)&&item.length>0">
            <div
              :class="['courseBox',obj['status']===1?'course1':'',obj['status']===2?'course2':'',obj['status']===3?'course3':'']"
              v-for="(obj,inIndex) in item" :key='index+inIndex'
            >
              <div class="courseName" @click="jumpToYunJiao(obj.course_title)">{{ obj.course_title }}</div>
              <div class="courseCredit">({{ obj.credit }}学分)</div>
              <div class="courseStatus">
                {{ switchStatus(obj['status']) }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import trainMangeApi from '../../../api/trainMange'
import trainUse from '../../../api/trainUse'

export default {
  name: 'StuCourse',
  components: {},
  computed: {
    ...mapState('trainUse', ['stuCourseData'])
  },
  data() {
    return {
      loading: false,
      courseData: [],
      title: '',// 培养计划标题
      degree: '',// 授予学士学位
      train_target: '',// 培养目标
      gradu_req: '',// 毕业要求
    }
  },
  created() {
  },
  mounted() {
    this.academicPlanningCourse({grade_id: this.stuCourseData.id, course_type_status: 2})
    trainMangeApi.getRelationTitle({id: this.stuCourseData.id}).then(res => {
      if (res && res.code === 10000) {
        this.title = res.data.title
        this.degree = res.data.degree
        this.train_target = res.data.train_target
        this.gradu_req = res.data.gradu_req
      }
    })
  },
  methods: {
    academicPlanningCourse(params) {
      trainUse.academicPlanningCourse(params).then(res => {
        if (res.code === 10000) {
          this.courseData = []
          res.data.forEach(item => {
            item.forEach(obj => {
              this.courseData.push(obj)
            })
          })
        }
      })
    },
    changeCourseType(status) {
      this.academicPlanningCourse({grade_id: this.stuCourseData.id, course_type_status: status})
    },
    jumpToYunJiao(title) {
      window.open(`${window.CONFIG.yunjiaoHostUrl}?title=${title}&realname=&trans=&page=1`, '_blank');
    },
    switchStatus(status) {
      switch (status) {
        case 1:
          return '学习完成';
        case 2:
          return '正在学习';
        case 3:
          return '尚未学习';
        default:
          return ''
      }
    },
    switchStep(step) {
      switch (step) {
        case 0:
          return '一';
        case 1:
          return '二';
        case 2:
          return '三';
        case 3:
          return '四';
        case 4:
          return '五';
        case 5:
          return '六';
        case 6:
          return '七';
        case 7:
          return '八';
        default:
          return '一'
      }
    },
  },

}
</script>

<style lang="less" scoped>

.pageContainer {
  width: 100%;
  min-height: 100%;
  background-color: #f4f4f4;
  padding: 35px 260px;
  box-sizing: border-box;

  .stuCourseCont {
    background-color: #fff;
    padding: 40px 100px;
    min-height: 100%;

    .topCont {
      margin-bottom: 30px;

      .title {
        height: 21px;
        text-align: center;
        margin-bottom: 35px;
        font-size: 21px;
        font-weight: 600;
      }

      .title2 {
        height: 21px;
        text-align: center;
        margin-bottom: 35px;
        font-size: 21px;
      }

      .title3 {
        display: flex;
        margin-bottom: 20px;
        line-height: 22px;

        div:nth-child(1) {
          width: 78px;
          flex-shrink: 0;
        }
      }

      .subTitle {
        display: flex;
        justify-content: center;

        div {
          width: 350px;
          height: 42px;
          line-height: 42px;
          text-align: center;
          cursor: pointer;
          padding: 0 15px;
          font-size: 21px;
          font-weight: 600;
          color: #ffffff;
          background-color: #409efd;
          border-color: #409eff;
          border-radius: 8px;

          span {
            font-size: 14px;
            margin-left: 5px;
            margin-bottom: 3px;
            font-weight: 400;
          }
        }

        .leftSub {
          margin-right: 60px;
        }
      }
    }

    .middleCont {
      li:not(:last-child) {
        margin-bottom: 15px;
        padding-bottom: 8px;
        //border-bottom: 1px solid #e0e0e0;
        &::after {
          content: "";
          width: 100%;
          //border-bottom: 1px solid #e0e0e0;
          border-bottom: 1px solid rgba(224, 224, 224, 0.5);
          display: inline-block;
        }
      }

      .stepTitleCont {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .titleIcon {
          width: 25px;
          height: 35px;
          background-image: url("../../../assets/titleIcon.png");
          background-size: cover;
          margin-right: 12px;
        }

        .stepTitle {
          font-size: 20px;
          font-weight: 600;
        }
      }

      .courseCont {
        display: flex;
        flex-wrap: wrap;
        padding: 0 20px;

        .courseBox {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 160px;
          height: 80px;
          margin-right: 80px;
          margin-bottom: 25px;
          padding: 7px 15px;
          font-size: 14px;
          border-radius: 12px;
          box-shadow: 10px 10px 5px #f7f7f7;

          .courseCredit {
            color: #363333;
            font-size: 16px;
            margin-bottom: 10px;
          }

          .courseName {
            color: #414545;
            font-size: 16px;
            margin-bottom: 10px;
            cursor: pointer;
          }
        }

        .course1 {
          background-color: #f9fced;

          .courseStatus {
            color: #4b7914;
          }
        }

        .course2 {
          background-color: #c9f5fd;

          .courseStatus {
            color: #01a7f0;
          }
        }

        .course3 {
          background-color: #fbfbfb;

          .courseStatus {
            color: #aaaaaa;
          }
        }

      }

    }

  }
}


</style>
